<ciciam-frame-front>
  <div class="flex flex-row">{{ error | translate }}</div>
</ciciam-frame-front>
